import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Film = createReactComponent("Film", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "2",
  width: "20",
  height: "20",
  rx: "2.18",
  ry: "2.18",
  key: "1salsp"
}], ["line", {
  x1: "7",
  y1: "2",
  x2: "7",
  y2: "22",
  key: "18n2oj"
}], ["line", {
  x1: "17",
  y1: "2",
  x2: "17",
  y2: "22",
  key: "1rnemm"
}], ["line", {
  x1: "2",
  y1: "12",
  x2: "22",
  y2: "12",
  key: "1vcgga"
}], ["line", {
  x1: "2",
  y1: "7",
  x2: "7",
  y2: "7",
  key: "d12ql1"
}], ["line", {
  x1: "2",
  y1: "17",
  x2: "7",
  y2: "17",
  key: "1yu0kk"
}], ["line", {
  x1: "17",
  y1: "17",
  x2: "22",
  y2: "17",
  key: "14cddp"
}], ["line", {
  x1: "17",
  y1: "7",
  x2: "22",
  y2: "7",
  key: "m1e22e"
}]]]);
export default Film;